import keycloak from "./keycloak";

const UPDATE_TOKEN_TIMEOUT_MS = parseInt(
  process.env.REACT_APP_KEYCLOAK_REFRESH_TIMEOUT_MS || "30000",
  10
);

/** True if access token is still valid for at least minValidity seconds (JWT `exp`). */
export function accessTokenFreshSeconds(minValidity = 30) {
  try {
    const exp = keycloak.tokenParsed?.exp;
    if (typeof exp !== "number") return false;
    return exp * 1000 > Date.now() + minValidity * 1000;
  } catch {
    return false;
  }
}

/**
 * Refresh only when needed; never block on Keycloak indefinitely (common cause of "stuck loading").
 */
export async function ensureAccessToken(minValidity = 30) {
  if (!keycloak.authenticated || !keycloak.token) return;
  if (accessTokenFreshSeconds(minValidity)) return;
  await Promise.race([
    keycloak.updateToken(minValidity),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Keycloak updateToken timeout")), UPDATE_TOKEN_TIMEOUT_MS)
    ),
  ]);
}

/**
 * Force a token refresh so the caller starts with the FULL access-token lifespan.
 * Used before large/long uploads where the request body can take minutes to
 * transfer — a token that is merely "still valid now" may expire mid-upload
 * before the backend validates it. Best-effort: never throws.
 */
export async function forceRefreshAccessToken() {
  if (!keycloak.authenticated || !keycloak.token) return;
  try {
    await Promise.race([
      // -1 forces Keycloak to refresh regardless of remaining validity.
      keycloak.updateToken(-1),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error("Keycloak updateToken timeout")), UPDATE_TOKEN_TIMEOUT_MS)
      ),
    ]);
  } catch {
    /* keep existing token — interceptor / 401-retry will handle expiry */
  }
}
